import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "b-profile-contact" }
const _hoisted_2 = { class: "b-profile-worker-page__title h-mb-50" }
const _hoisted_3 = { class: "b-profile-contact__back--icon" }
const _hoisted_4 = { class: "b-profile-contact--title" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoBackButton = _resolveComponent("GoBackButton")!
  const _component_EditWorkerForm = _resolveComponent("EditWorkerForm")!
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_GoBackButton, { routeString: `ProfileWorkerPage` })
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('WORKER.DETAILS')), 1)
    ]),
    (_ctx.worker)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_EditWorkerForm, {
            editAvatarPermission: false,
            worker: _ctx.worker,
            showSubmit: false,
            disabledForm: true,
            isDisabled: true,
            iconName: `lock`,
            submitText: _ctx.$t(`BUTTON.SAVE`)
          }, null, 8, ["worker", "submitText"])
        ]))
      : (_openBlock(), _createBlock(_component_FwSpinLoader, {
          key: 1,
          colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
          class: "h-flex-center loader",
          isActive: _ctx.loading,
          className: "h-p-20"
        }, null, 8, ["isActive"]))
  ]))
}